import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "..";

const getAllComments = async () => {

    const comments = []

    const today = Date.now()
    const q = query(collection(db, "comments"));


    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
            comments.push({ id: doc.id, ...doc.data() })
    });
    return comments
}

export default getAllComments